export const API_ENDPOINTS = {
  CLAIM: {
        GET_POLICY_HOLDERS_DROPDOWN: "Claim/GetPolicyHoldersDropDown",
        SAVE_BANK_DETAIL: "Claim/SaveBankDetail",
        UPDATE_BANK_DETAIL: "Claim/UpdateBankDetail",
        SAVE: "Claim/Save",
        UPDATE: "Claim/Update",
        DELETE: 'Claim/Delete',
        GET_BY_ID: 'Claim/GetById',
        GET_CLAIM_SERVICES:'Claim/GetClaimedServices',
        SEARCH: "Claim/Search",
        UPDATE_STATUS: "Claim/UpdateStatus",
        AWAITINGAPPROVAL_STATUS: "Claim/UpdateAwaitingApprovalStatus",
        APPROVED_STATUS: "Claim/ApprovedStatus",
        REJECTED_STATUS: "Claim/RejectedStatus",
        PAID_STATUS: "Claim/UpdatePaidStatus",
        UNDO_PAID_STATUS: "Claim/UndoPaidStatus",
        GET_SETTINGS: "Claim/GetClaimSettings",
        UPLOAD_FILES: "Claim/uploadFiles",
        EXPORT: "Claim/Export",
        DETAIL: "Claim/GetDetailById",
        DELETE_BANKDETAIL: "BankDetail/Delete",
        ADD_BANKDETAIL: "BankDetail/Save",
        UPDATE_BAKDETAIL: "BankDetail/Update"
    },
 
};

export const QUERY_KEYS = {
  
  CLAIM: {
        GET_POLICY_HOLDERS_DROPDOWN: ["ClaimGetPolicyHoldersDropDown"],
        SAVE_BANK_DETAIL: ["ClaimSaveBankDetail"],
        UPDATE_BANK_DETAIL: ["ClaimUpdateBankDetail"],
        SAVE: ["ClaimSave"],
        UPDATE: ["ClaimUpdate"],
        DELETE: ["ClaimDelete"],
        GET_BY_ID: ["ClaimGetById"],
        SEARCH: ["ClaimSearch"],
        UPDATE_STATUS: ["ClaimUpdateStatus"],
        UPLOAD_FILES: ["ClaimUploadFiles"],
        DETAIL: ["ClaimDetail"]
    },
};